export type UserExperimentResponse = Record<string, string>;

export const userExperimentResponseMock: UserExperimentResponse = {
  chiron_platform_alignment_app: "off",
  ela_reading_skills: "off",
  read_aloud_quizzes: "off",
  formative_curated_connection: "Experiment",
  reading_skills_recommendations_experiment_test: "variation_2_videos",
  ela_skills_grading_link: "ineligible",
  recently_view_cache_OLD: "ineligible",
  admin_ela_skills_dashboard: "on",
  HP_redesign_visibility: "on",
  recently_view_cache: "on",
  view_page_tiptap: "ineligible",
  create_content_promotions_settings: "on",
  "use-oauth-formative": "Experiment",
  trial_homepage_printable_content: "ineligible",
  new_teacher_homepage: "on",
  "homepage-breaking-news-old": "on",
};
